var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiograf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#021e3a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.761,4.44H2.555a.772.772,0,0,0-.772.772V10.2a.772.772,0,0,0,.772.772H4.1a.426.426,0,0,0,.062.013h6.988a.44.44,0,0,0,.063-.013h1.546a.772.772,0,0,0,.772-.772V5.212A.772.772,0,0,0,12.761,4.44ZM3.65,10.2H2.555V9.572H3.65Zm0-1.4H2.555V8.075H3.65Zm0-1.5H2.555V6.577H3.65Zm0-1.5H2.555V5.212H3.65ZM8.891,8l-.586.339-1.011.584-.587.338c-.278.161-.5.029-.5-.292V6.447c0-.321.227-.453.5-.292l.587.338,1.011.584.586.339A.308.308,0,0,1,8.891,8Zm3.87,2.2H11.667V9.572h1.094Zm0-1.4H11.667V8.075h1.094Zm0-1.5H11.667V6.577h1.094Zm0-1.5H11.667V5.212h1.094Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiograf);
export default __webpack_public_path__ + "static/media/BIOGRAF.5135e4ce1bf9cf9d733ca82bc5dcca61.svg";
export { ForwardRef as ReactComponent };